import mixins from 'vue-typed-mixins';

import { Eフェーズ種別, E有無フラグ, E計画表示モード } from '@/openapi/enum';

import C勘定科目ListEditModeToggleButton from '@/components/勘定科目/listEdit/button/modeToggle/勘定科目ListEditModeToggleButton.vue';
import C勘定科目ListEditNewButton from '@/components/勘定科目/listEdit/button/new/勘定科目ListEditNewButton.vue';
import C勘定科目ListEditDialog from '@/components/勘定科目/listEdit/dialog/勘定科目ListEditDialog.vue';
import CF計算書 from '@/entries/user/pages/authorized/事業所/計画書/計画/三表/CF計算書/CF計算書.vue';
import 損益計算書 from '@/entries/user/pages/authorized/事業所/計画書/計画/三表/損益計算書/損益計算書.vue';
import 貸借対照表 from '@/entries/user/pages/authorized/事業所/計画書/計画/三表/貸借対照表/貸借対照表.vue';

import Plbscf要約表示Mixin from '@/entries/user/mixins/Plbscf要約表示Mixin';
import RoutesMixin from '@/entries/user/mixins/RoutesMixin';
import 計画PlbscfMixin from '@/entries/user/mixins/計画PlbscfMixin';
import 計画書データ表示設定Mixin from '@/entries/user/mixins/計画書データ表示設定Mixin';
import 計画貸借対照表Mixin from '@/entries/user/mixins/計画貸借対照表Mixin';
import EventObserverMixin from '@/mixins/EventObserverMixin';

import { PlbscfType } from '@/master/Plbscf';

export default mixins(
  EventObserverMixin,
  RoutesMixin,
  計画PlbscfMixin,
  計画書データ表示設定Mixin,
  計画貸借対照表Mixin,
  Plbscf要約表示Mixin
).extend({
  name: 'P三表',

  components: {
    tab0: 貸借対照表,
    tab1: 損益計算書,
    tab2: CF計算書,
    C勘定科目ListEditNewButton,
    C勘定科目ListEditModeToggleButton,
    C勘定科目ListEditDialog,
  },

  data(): {
    tabTypes: PlbscfType[];
    e計画表示モード: typeof E計画表示モード;
    c計画表示モード: E計画表示モード | null;
  } {
    return {
      tabTypes: [PlbscfType.貸借対照表, PlbscfType.損益計算書, PlbscfType.CF計算書],
      e計画表示モード: E計画表示モード,
      c計画表示モード: null,
    };
  },

  computed: {
    計画表示モードOptions(): E計画表示モード[] {
      return this.計画書.c第1期月次作成フラグ === E有無フラグ.あり
        ? [E計画表示モード.月次計画第0期, E計画表示モード.月次計画第1期, E計画表示モード.年次計画]
        : [E計画表示モード.月次計画第0期, E計画表示モード.年次計画];
    },
    第1期月次CheckDisabled(): boolean {
      return this.事業所.c計画作成期間 === 0 || this.c計画表示モード === E計画表示モード.月次計画第1期;
    },
    canEdit勘定科目(): boolean {
      return !this.isCF計算書Tab && !this.is補助科目別貸借対照表 && !this.is科目別損益計算表;
    },
  },

  watch: {
    async isEditing(): Promise<void> {
      if (!this.isEditing) return;
      await this.saveデータ(
        this.service.getTデータPlbscfs,
        this.service.getTデータ科目別計画Configs,
        Eフェーズ種別.計画フェーズ,
        this.service.getTデータYearConfigs
      );

      // 再load or 再計算
      if (this.reloadFlag) {
        await this.load();
      } else {
        this.計画Plbscf = this.service.calcAndCreate計画Plbscf();
        this.initializeFlag();
      }
    },
    eventCount(): void {
      // EventObserverMixin.eventCount を監視、一覧での勘定科目並び順変更、削除、科目別計画フラグの活性化　を想定
      this.load();
    },
  },

  created(): void {
    this.c計画表示モード = this.計画書.c計画表示モード;
  },

  methods: {
    async change計画表示モード(): Promise<void> {
      if (this.c計画表示モード === null) return;
      await this.save計画書データ表示設定({ c計画表示モード: this.c計画表示モード });
      this.onChange表示設定();
    },
  },
});
